import { Theme, ThemeDefaultParams, themeQuartz } from "ag-grid-community";

import theme, { fontFamily } from "fond/theme";

export const baseTheme = themeQuartz.withParams({
  accentColor: theme.palette.primary.main,
  oddRowBackgroundColor: "#fcfcfc",
  selectedRowBackgroundColor: "#ecf4fd",
  iconSize: 18,
  borderRadius: 4,
  borderWidth: 1,
  cellHorizontalPadding: 12,
  headerBackgroundColor: "#f8f8f8",
  headerHeight: 40,
  headerFontSize: 13,
  rowHeight: 40,
  fontFamily,
  fontSize: 14,
});

export const compactTheme = baseTheme.withParams({
  headerHeight: 31,
  headerFontSize: 11,
  fontSize: 12,
  rowHeight: 25,
  spacing: 4,
});

export const largeTheme = baseTheme.withParams({
  headerHeight: 48,
  rowHeight: 48,
});

const variants: Record<"borderless" | "outlined", Partial<ThemeDefaultParams>> = {
  borderless: {
    wrapperBorder: "none",
    wrapperBorderRadius: 0,
  },
  outlined: {
    wrapperBorder: "1px solid var(--theme-border-divider-color)",
    wrapperBorderRadius: 4,
  },
};

const themes: Record<"compact" | "standard" | "large", Theme> = {
  compact: compactTheme,
  standard: baseTheme,
  large: largeTheme,
} as const;

export const buildTheme = (size: "compact" | "standard" | "large" = "standard", variant: keyof typeof variants): Theme => {
  const theme = themes[size].withParams(variants[variant]);
  return theme;
};
